<section class="produto-shell">
  <header class="produto-hero">
    <div>
      <h2 class="produto-title">{{ isEditMode ? 'Editar Produto' : 'Novo Produto' }}</h2>
      <p class="produto-subtitle">Preencha os dados do produto.</p>
    </div>
    <span class="produto-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="produtoForm" (ngSubmit)="salvarProduto()" id="produtoForm" class="produto-card">
    <div class="form-section">
      <h3>Dados do Produto</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="nomeProduto" class="form-label">Nome do Produto</label>
          <input type="text" id="nomeProduto" formControlName="nomeProduto" class="form-control"
            [ngClass]="{ 'is-invalid': produtoForm.get('nomeProduto')?.invalid && produtoForm.get('nomeProduto')?.touched }">
          <div *ngIf="produtoForm.get('nomeProduto')?.invalid && produtoForm.get('nomeProduto')?.touched" class="invalid-feedback">
            Nome do Produto é obrigatório.
          </div>
        </div>
        <div class="col-md-12">
          <label for="descricao" class="form-label">Descrição</label>
          <input type="text" id="descricao" formControlName="descricao" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="tipo" class="form-label">Tipo</label>
          <select id="tipo" formControlName="tipo" class="form-select">
            <option value="">Selecione...</option>
            <option *ngFor="let c of categoriasProduto" [value]="c.descricao">
              {{ c.descricao }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label for="classe" class="form-label">Classe</label>
          <select id="classe" formControlName="classe" class="form-select">
            <option value="">Selecione...</option>
            <option *ngFor="let c of classesProduto" [value]="c.valorMaximo">
              {{ c.valorMaximo }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label for="dimensaoUnitariaM2" class="form-label">Dimensão Unitária (M²)</label>
          <input type="number" id="dimensaoUnitariaM2" formControlName="dimensaoUnitariaM2" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="codigoBarra" class="form-label">Código de Barra</label>
          <input type="text" id="codigoBarra" formControlName="codigoBarra" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="sku" class="form-label">SKU</label>
          <input type="text" id="sku" formControlName="sku" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="unMedida" class="form-label">Unidade de Medida</label>
          <select id="unMedida" formControlName="unMedida" class="form-select" data-testid="produto-un-medida">
            <option value="">Selecione...</option>
            @for (u of unidadesMedida; track u) {
              <option [value]="u">{{ u }}</option>
            }
          </select>
          <div class="form-text">Unidades como KG, L, M e M2 permitem quantidade fracionada na venda (ex.: 1,5 KG).</div>
        </div>
      </div>
    </div>

    <div class="form-section" formGroupName="ncm">
      <h3>NCM</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="codigo" class="form-label">NCM - Código</label>
          <div class="d-flex gap-2">
            <input
              type="text"
              id="codigo"
              formControlName="codigo"
              class="form-control"
              [style.pointer-events]="isReadOnly ? 'none' : 'auto'"
              [style.background-color]="isReadOnly ? '#e9ecef' : '#fff'">
            <button class="btn btn-outline-success" type="button" (click)="pesquisarNcm()">Pesquisar</button>
          </div>
        </div>
        <div class="col-md-6">
          <label for="ncmDescricao" class="form-label">NCM - Descrição</label>
          <input type="text" id="ncmDescricao" formControlName="descricao" class="form-control"
            [style.pointer-events]="isReadOnly ? 'none' : 'auto'"
            [style.background-color]="isReadOnly ? '#e9ecef' : '#fff'">
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="produtoForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>

<app-ncm-modal [isOpen]="isNcmModalOpen" (closeModal)="pesquisarNcm()"></app-ncm-modal>
